import _ from 'lodash'

export default function getOrderPrices(order) {
  return {
    currencyCode: _.get(order, 'overrideCurrencyCode') || _.get(order, 'currencyCode'),
    deliveryFee:
      _.get(order, 'priceDetails.deliveryFee')
      || _.get(order, 'priceDetails.orderDeliveryFee')
      || _.get(order, 'shippingCharge'),
    serviceCharge:
      _.get(order, 'priceDetails.serviceCharge')
      || _.get(order, 'priceDetails.ordersServiceCharge')
      || _.get(order, 'serviceCharge'),
    vouchers: _.get(order, 'priceDetails.voucherAmount'),
    // discounts could be an array of discounts or a string value
    discountGroup:
      _.get(order, 'priceDetails.discountGroup')
      || _.get(order, 'priceDetails.orderDiscountGroup'),
    totalDiscount: _.get(order, 'priceDetails.totalDiscount')
      || _.get(order, 'priceDetails.orderDiscount')
      || _.get(order, 'discountedPrice'),
    subtotal:
      _.get(order, 'priceDetails.subtotalPrice')
      || _.get(order, 'priceDetails.orderSubtotalPrice')
      || _.get(order, 'subtotalPrice'),
    // TODO: add tax
    // tax: 0,
    totalLoyaltyPoints: _.get(order, 'loyaltyPointConsumed')
      || _.get(order, 'priceDetails.totalLoyaltyPoints'),
    total:
      _.get(order, 'priceDetails.totalPrice')
      || _.get(order, 'priceDetails.orderTotalPrice')
      || _.get(order, 'totalPrice'),
  }
}
